import React from 'react';

const EllipseProgressBarIcon = ({
    width = 140,
    height = 69,
    fill = '#F2F2F2',
    stroke = 'none',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 140 69"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.6 69C2.50721 69 -0.0239384 66.4885 0.2304 63.4062C0.81997 56.2613 2.53654 49.2388 5.32844 42.5948C8.84626 34.2234 14.0024 26.6169 20.5025 20.2096C27.0026 13.8024 34.7194 8.71988 43.2122 5.25231C51.705 1.78474 60.8075 -1.18823e-06 70 0C79.1925 1.18823e-06 88.2951 1.78474 96.7878 5.25231C105.281 8.71989 112.997 13.8024 119.497 20.2096C125.998 26.6169 131.154 34.2234 134.672 42.5948C137.463 49.2388 139.18 56.2613 139.77 63.4063C140.024 66.4886 137.493 69 134.4 69C131.307 69 128.828 66.4869 128.526 63.4089C127.966 57.715 126.553 52.1237 124.324 46.8197C121.369 39.7876 117.038 33.3982 111.578 28.0161C106.118 22.634 99.6357 18.3647 92.5018 15.4519C85.3679 12.5392 77.7217 11.04 70 11.04C62.2783 11.04 54.6322 12.5392 47.4982 15.4519C40.3643 18.3647 33.8822 22.634 28.4221 28.0161C22.962 33.3982 18.6309 39.7876 15.6759 46.8197C13.447 52.1237 12.034 57.715 11.4742 63.4089C11.1716 66.4868 8.6928 69 5.6 69Z"
                fill={fill}
                stroke={stroke}
            />
        </svg>
    );
};

export default EllipseProgressBarIcon;
